(() => {
  if (window.fsCollectionEvents) return;
  window.fsCollectionEvents = true;
  const roots = document.querySelectorAll('[data-fs-collection]');
  const seen = new WeakSet();
  const allowed = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  const publish = (event, card) => {
    if (!allowed()) return;
    const root = card.closest('[data-fs-collection]');
    if (!root) return;
    const data = {collection_id: root.dataset.fsCollection, product_id: card.dataset.fsProductId, product_name: card.dataset.fsProductName, position: Number(card.dataset.fsProductIndex), language: document.documentElement.lang};
    if (window.fsCommerce) { window.fsCommerce.capture(event, data); return; }
    // English commerce events must always use the consent/preview-aware bridge.
    if (document.documentElement.lang === 'en') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({event, ...data});
  };
  const observe = () => {
    if (!allowed()) return;
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting || seen.has(entry.target)) return;
      if (!allowed()) return;
      seen.add(entry.target);
      publish('fs_collection_product_viewed', entry.target);
      observer.unobserve(entry.target);
    }), {threshold: 0.5});
    roots.forEach(root => root.querySelectorAll('[data-fs-product-id]').forEach(card => {if (!seen.has(card)) observer.observe(card);}));
  };
  roots.forEach(root => {
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href*="/products/"]');
      const card = link?.closest('[data-fs-product-id]');
      if (card) publish('fs_collection_product_selected', card);
    });
    root.addEventListener('submit', event => {
      const card = event.target.closest('[data-fs-product-id]');
      if (card) publish('fs_collection_add_to_cart_intent', card);
    });
  });
  observe();
  document.addEventListener('visitorConsentCollected', observe);
  window.addEventListener('load', observe, {once: true});
})();
